// Curseur avant / après : le range (accessible au clavier) pilote la variable --position.
if (!customElements.get('mp-avant-apres')) {
  customElements.define(
    'mp-avant-apres',
    class extends HTMLElement {
      connectedCallback() {
        const curseur = this.querySelector('input[type="range"]');
        if (!curseur) return;
        const maj = () => this.style.setProperty('--position', `${curseur.value}%`);
        curseur.addEventListener('input', maj);
        maj();
      }
    }
  );
}
